import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

var rand = 'app'
if (process.env.NODE_ENV === 'developmentx') {
  rand = Math.random()
}

const vuexPersist = new VuexPersist({
  key: `sensata_${rand}`,
  storage: localStorage
})

export default new Vuex.Store({
  state: {
    dataSet: [],
    responses: [],
    survey: {
      qid: 0,
      ResultsPage: {},
      disallowBackButton: false,
      surveyName: '',
      questionCount: 4,
      current: 0,
      status: '',
      showTestResults: false,
      weightedTestResults: [],
      browserReport: {}
    },
    testResults: [],
    user: {
      profileId: null,
      profile: {}
    },
    site: {
      pages: [],
      isLoaded: false,
      surveyIsLoaded: false
    }
  },
  mutations,
  actions,
  plugins: [vuexPersist.plugin]
})
